import { NextButtonField } from '../checkInReserve/nextButtonField';
import { InsuranceEntryField } from './insuranceEntryField';
import './insuranceEntryStyle.css';
import { InsuranceEntryItemType } from '@/types/bodyAndPaint';

interface CheckInUseInsuranceProps {
  state: InsuranceEntryItemType;
  setState: {
    insuranceSelect: (select: number) => void;
    companyPick: (pick: string) => void;
    certificateText: (text: string) => void;
    receiptNumberText: (text: string) => void;
    deductibleSelect: (select: number) => void;
    deductibleText: (text: string) => void;
    repairPlanSelect: (select: number) => void;
  };
  selectList: {
    insuranceSelect: string[];
    deductibleSelect: string[];
    repairPlanSelect: string[];
  };
  error: {
    certificateText: string;
    receiptNumberText: string;
    deductibleText: string;
  };
  pickerInfo: {
    inputID: string;
    containerID: string;
    select: string;
  };
  hasDeductible: boolean;
  addInsurance?: boolean;
  isInsurance: boolean;
  disabled: boolean;
  onNext: () => void;
}
export const CheckInUseInsurance = ({
  state,
  setState,
  selectList,
  error,
  pickerInfo,
  isInsurance,
  hasDeductible,
  addInsurance,
  disabled,
  onNext,
}: CheckInUseInsuranceProps) => {
  return (
    <div className={'check-in-use-insurance-field'}>
      <InsuranceEntryField
        state={state}
        setState={setState}
        selectList={selectList}
        error={error}
        isInsurance={isInsurance}
        hasDeductible={hasDeductible}
        addInsurance={addInsurance}
        picker={pickerInfo}
      />
      <NextButtonField disable={disabled} onClick={onNext} />
    </div>
  );
};
